import VisitReportList from './List'

export default function VisitReportListIndex(props) {
  return <VisitReportList {...props} />
}
